<script setup>
const props = defineProps({
  message: {
    type: String,
    default: "Ezee is searching",
  },
});
</script>

<template>
  <div class="loader-container">
    <p>{{ props.message }}</p>
    <b-spinner variant="secondary" class="spinner"></b-spinner>
  </div>
</template>

<style>
p {
  margin: 0;
}
.loader-container {
  display: flex;
  align-items: center;
  gap: 0.5em;
  width: 100%;
}
</style>
